<span [ngSwitch]="status.statusCode">
  <span class="badge-status grey" *ngSwitchCase="taskStatus.New">
    {{status.title}}
  </span>
  <span class="badge-status success-with-border" *ngSwitchCase="taskStatus.Active">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="taskStatus.Waiting_First_Review">
    {{status.title}}
  </span>
  <span class="badge-status purple" *ngSwitchCase="taskStatus.Modifications_Requested_From_First_Review">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="taskStatus.Waiting_Final_Review">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="taskStatus.Modifications_Requested_From_Final_Review">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="taskStatus.Waiting_Final_Approval">
    {{status.title}}
  </span>
  <span class="badge-status success-with-border" *ngSwitchCase="taskStatus.Final_Report_Approved">
    {{status.title}}
  </span>
  <span class="badge-status red_2" *ngSwitchCase="taskStatus.Final_Report_Rejected">
    {{status.title}}
  </span>
  <span class="badge-status success-with-border" *ngSwitchCase="taskStatus.Overdue">
    {{status.title}}
  </span>
</span>